import React, { Component } from 'react';
import DropdownButtonDropdown from './DropdownButtonDropdown';
import { safeOnClick } from '../util/helpers/event-helpers';

class DropdownButton extends Component {
  state = {
    open: false,
  };

  componentDidMount() {
    // close the dropdown if user clicks outside of dropdown
    window.addEventListener('click', this.closeDropdown);
    if (this.props.open) {
      this.toggleOpen();
    }
  }

  componentWillUnmount() {
    // cleanup
    window.removeEventListener('click', this.closeDropdown);
    clearTimeout(this._openTimer);
  }

  closeDropdown = () => {
    if (this.state.open) {
      this.setState({
        open: false,
      });
      // if there's a listener, fire it
      if (this.props.onToggleOpen) {
        this.props.onToggleOpen(false);
      }
    }
  };

  toggleOpen() {
    const open = !this.state.open;
    // NOTE: we use a timeout here so that toggle happens *after* all the other existing open dropdowns are closed
    this._openTimer = setTimeout(() => {
      this.setState({
        open,
      });
      // if there's a listener, fire it
      if (this.props.onToggleOpen) {
        this.props.onToggleOpen(open);
      }
    }, 1);
  }

  render() {
    const {
      children,
      className,
      contentBuilder,
      disabled,
      contentWidth,
      stopPropagation = false,
    } = this.props;

    return (
      <div
        onClick={safeOnClick(
          () => (disabled ? null : this.toggleOpen()),
          stopPropagation,
        )}
        className={className || ''}
        data-dropdown-button
      >
        {children}
        {this.state.open ? (
          <DropdownButtonDropdown
            contentWidth={contentWidth}
            contentBuilder={contentBuilder}
          />
        ) : null}
      </div>
    );
  }
}

export default DropdownButton;
